var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 0.9375H10.0312V0H9.09375V0.9375H2.90625V0H1.96875V0.9375H1.40625C0.630844 0.9375 0 1.56834 0 2.34375V10.5938C0 11.3692 0.630844 12 1.40625 12H10.5938C11.3692 12 12 11.3692 12 10.5938V2.34375C12 1.56834 11.3692 0.9375 10.5938 0.9375ZM11.0625 10.5938C11.0625 10.8522 10.8522 11.0625 10.5938 11.0625H1.40625C1.14778 11.0625 0.9375 10.8522 0.9375 10.5938V4.40625H11.0625V10.5938ZM11.0625 3.46875H0.9375V2.34375C0.9375 2.08528 1.14778 1.875 1.40625 1.875H1.96875V2.8125H2.90625V1.875H9.09375V2.8125H10.0312V1.875H10.5938C10.8522 1.875 11.0625 2.08528 11.0625 2.34375V3.46875Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 5.39062H1.78125V6.32812H2.71875V5.39062Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 5.39062H3.65625V6.32812H4.59375V5.39062Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 5.39062H5.53125V6.32812H6.46875V5.39062Z",
    fill: "#888888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 5.39062H7.40625V6.32812H8.34375V5.39062Z",
    fill: "#888888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 5.39062H9.28125V6.32812H10.2188V5.39062Z",
    fill: "#888888"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 7.26562H1.78125V8.20312H2.71875V7.26562Z",
    fill: "#888888"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 7.26562H3.65625V8.20312H4.59375V7.26562Z",
    fill: "#888888"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 7.26562H5.53125V8.20312H6.46875V7.26562Z",
    fill: "#888888"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 7.26562H7.40625V8.20312H8.34375V7.26562Z",
    fill: "#888888"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 9.14062H1.78125V10.0781H2.71875V9.14062Z",
    fill: "#888888"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 9.14062H3.65625V10.0781H4.59375V9.14062Z",
    fill: "#888888"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 9.14062H5.53125V10.0781H6.46875V9.14062Z",
    fill: "#888888"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 9.14062H7.40625V10.0781H8.34375V9.14062Z",
    fill: "#888888"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 7.26562H9.28125V8.20312H10.2188V7.26562Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.af5bd478.svg";
export { ForwardRef as ReactComponent };